import React, { useEffect, useState, useRef, useMemo } from 'react';
import style from './woundAssessment.module.scss';
import { useParams } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import LogoImage from '../../../static/images/measurmenttest.jpg';
import { Modal } from '../../secondary/Modal/modal';
import {  patientAssessmentHistoryAsync, patientAssessmentAsync, ne1updateassessmentsignlockAsync, setAssessmentHistory, createNewParentFromChild, setChildAsItsOwnParent, setDetailAssessment, setWoundAssessment, getConsolidatePdfAsync, setConsolidatePdfStatus } from '../../../app/patientSlice';
import { format } from 'date-fns'
import { setLoading } from '../../../app/appSlice';
import Loader from '../../../static/images/spinner.svg';
import { assessmentStageGetterMove, fullMonthFormatDate, pdfPageMove, allNullCheck} from '../../../utils';
import { Button } from '../../primary/Button/button';
import PDFIcon from '../../../static/images/pdfIcon.svg';
import { handleDeleteData, openDeleteConfirmationData, modalOpenData } from '../../../utils/patientsHelper';
import { Confirmation } from '../../secondary/Confirmation/confirmation';
import warning from '../../../static/images/icon-check-danger.png';
import { setDeleteAdminChildStatus } from '../../../app/appSlice'; 
import { CONSOLIDATE_PDF_MAX_COUNT, DEFAULT_ASSESSMENT_LIMIT_OFFSET } from '../../../constants';
import { isAdministrator } from '../../../utils/rbac';
import { useNavigate } from 'react-router-dom';
import { useAdminView } from '../../../hooks/useAdminView';
import { getHistoryCauseText } from '../../../utils/getHistoryCauseText';
import { trendConfig } from './trendConfig';

export const AssessmentHistory = ({ modalOpen, modalTitlteId, setmodalShow, deleteAssessment, deleteHistoryAssessment, childLevelDelete, setChildLevelDelete, setNewWoundOptionChildLevel, modalType }) => {
  const isAdminView = useAdminView();
  const { patientId } = useParams();
  const assessmentId = modalTitlteId; 
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const assessmnetHistoryData = useSelector(state => state.patient.assessmentHistory);
  const childAsItsOwnParentAssessment = useSelector(state => state.patient.childAsItsOwnParent);
  const patientData = useSelector(state => state.patient.detailViewData);
  const consolidatePdfStatus = useSelector(state => state.patient.consolidatePdfStatus);
  const consolidatePdfLoading = useSelector(state => state.patient.consolidatePdfLoading);
  const historyCause = useSelector(state => state.patient.historyCause);
  const woundProgress = useSelector(state => state.patient.woundProgress);
  const deleteAdminChildStatus = useSelector((state) => state.app.deleteAdminChildStatus); 
  const detailAssessment = useSelector(state=>state.patient.detailAssessment)
  const userRole = useSelector(state => state.user);
  const adminAccess = isAdministrator(userRole?.role);

  const [selectedIdsByWound, setSelectedIdsByWound] = useState({});
  const [tinyDelay, setTinyDelay] = useState(false);
  // click on three dots action 
  const [historyId, setHistoryId] = useState(); //PDf Popup Getting ID from assessment history list
  const [clickThreeDots, setClickThreeDots] = useState("")
  const [openTooltip, setOpenTooltip] = useState(false)
  const [pdfModal, setPdfModal] = useState(false)
  const [assessmentIdValue, setAssessmentId] = useState();
  const [historyAssessmentId, setHistoryAssessmentId] = useState();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)
  const [assessTitleContent, setAssessTitleContent] = useState('')
  const [hoverUnlockIcon, setHoverUnlockIcon] = useState(false)
  const [hoverMergeIcon, setHoverMergeIcon] = useState(false)
  const [hoverTransferIcon, setHoverTransferIcon] = useState(false)
  const [hoverDeleteIcon, setHoverDeleteIcon] = useState(false)
  const [hoverNewWound, setHoverNewWound] = useState(false)
  const [lockUnlockToggle, setLockUnlockToggle] = useState(false)
  const [lockUnlockToggleLockedOne, setLockUnlockToggleLockedOne] = useState(false)
  const [lockUnlockToggleLockedZero, setLockUnlockToggleLockedZero] = useState(false)
  const [lockUnlockToggleLockedOnePopup, setLockUnlockToggleLockedOnePopup] = useState(false)
  const [lockUnlockToggleLockedZeroPopup, setLockUnlockToggleLockedZeroPopup] = useState(false)
  const [lockUnlockDone, setLockUnlockDone] = useState(false)
  const [getObject, setGetObject] = useState({})
  const [toggleClicked, setToggleClicked] = useState(false)
  const [latestReEval, setLatestReEval] = useState(false)
  const [lockUnlockToastMsg, setLockUnlockToastMsg] = useState(false)
  const [onNewWoundCreateConfirm, setOnNewWoundCreateConfirm] = useState(false)
  const [onNewWoundCreateId, setOnNewWoundCreateId] = useState()

  useEffect(() => {
    dispatch(patientAssessmentHistoryAsync(patientId, assessmentId));
  }, [patientId, assessmentId, dispatch])

  useEffect(() => {
    setHoverUnlockIcon(false)
    setShowDeleteConfirmation(false)
    setTinyDelay(false)
    setClickThreeDots('')
    setOpenTooltip(false)
    setHoverUnlockIcon(false)
    setHoverMergeIcon(false)
    setHoverDeleteIcon(false)
    setLockUnlockToggle(false)
    setLockUnlockToggleLockedOne(false)
    setLockUnlockToggleLockedZero(false)
    setLockUnlockDone(false)
    setLockUnlockToggleLockedZeroPopup(false)
    setLockUnlockToggleLockedOnePopup(false)
    if(isAdminView || adminAccess){
      setNewWoundOptionChildLevel(false)
    }
  }, [])

useEffect(()=>{
  let getloadValue = assessmnetHistoryData?.followuphistory?.map(data=>data?.assessments?.map(item=>item)) !== undefined ? true : false
  if(getloadValue){
    setTimeout(()=>{
      setTinyDelay(true)
    }, 1000)    
  }    
 })

 useEffect(() => {
      if (consolidatePdfStatus === "success") {
        setConsolidatePdfStatus("")
      }
      setTimeout(() => {
        dispatch(setConsolidatePdfStatus(""))
      }, 2500)
    }, [consolidatePdfStatus, dispatch])

  // Delete assessment id after confirmation message purpose
  useEffect(()=>{
    if(deleteAdminChildStatus && childLevelDelete){   
      setTinyDelay(false)  
      loadOffAssessmentDelete()     
    }
  },[deleteAdminChildStatus, childLevelDelete])

  const loadOffAssessmentDelete = () => {
    setTimeout(()=>{
      setTinyDelay(true)
      setOpenTooltip(false)
      setClickThreeDots('')
      setHoverUnlockIcon(false)
      setHoverMergeIcon(false)
      setHoverDeleteIcon(false)
      dispatch(setDeleteAdminChildStatus(false))
      if(isAdminView || adminAccess){
        setChildLevelDelete(false)
      }                
    },5000) 
  }

  const modalRefresh = () => {
    setmodalShow(false);
  }

  // redirect to assessment details screen fn
  const detaileView = (data) => {
    if (userRole.role !== 'ExternalStandardUser') {
      navigate('/patients/' + patientId + '/assessment/' + data);
      modalRefresh();
    }
  }

  const pdfmodalopen = () => { //added for Pdf with/without Image
    setPdfModal(true);
  }
  const pdfmodalclose = () => {
    setPdfModal(false)
  }

  //added for Pdf with/without Image
  const pdfPageTrue = (data) => {  
    let showImage = true
    pdfPageMove(data, dispatch, setLoading, navigate, patientId, modalRefresh, showImage)
  }
  const pdfPageFalse = (data) => { 
    let showImage = false 
    pdfPageMove(data, dispatch, setLoading, navigate, patientId, modalRefresh, showImage)
  }
  //added for Pdf with/without Image

  const assessmentStageGetter = (data) => {
    return assessmentStageGetterMove(data)
  }

  const threeDotPanelClick = (assessmentID) => {
    dispatch(setDetailAssessment({}));
    if(assessmnetHistoryData?.followuphistory?.map(data=>data?.assessments?.map(item=>item.id===assessmentID))){
      setClickThreeDots(assessmentID)
      setOpenTooltip(true)
      setLockUnlockToggle(false)
      setLockUnlockToastMsg(false)
    } 
    assessmnetHistoryData?.followuphistory?.map(data=>{
      data?.assessments?.map(item=>{
        if(item?.isLocked === 1){
          setLockUnlockToggleLockedOne(true)           
        }
        else{
          setLockUnlockToggleLockedZero(false)
        }
      })
    }) 
  }

  // outside click on three dots action
  const wrapperRef = useRef(null)
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = event => {
    if (!wrapperRef?.current?.contains(event.target)) {
      setOpenTooltip(false)
      setClickThreeDots("")
      setLockUnlockToggle(false)       
      assessmnetHistoryData?.followuphistory?.map(data=>{
        data?.assessments?.map(item=>{
          if(item?.isLocked === 1){
            setLockUnlockToggleLockedOne(true)           
          }
          else{
            setLockUnlockToggleLockedZero(false)
          }
        })
      })
    }
    else{
      setOpenTooltip(true)  
      setLockUnlockToggle(false)    
    }
  };

  // Delete Functionlaity for each assessment
  
  const openDeleteConfirmation = (_assessmentId, _historyAssessmentId, woundTitle) => {
    setAssessTitleContent(woundTitle)
    openDeleteConfirmationData(_assessmentId, _historyAssessmentId, setAssessmentId, setHistoryAssessmentId, setShowDeleteConfirmation)
  }

  const handleDelete = () => {
    handleDeleteData(historyAssessmentId, deleteHistoryAssessment, assessmentIdValue, deleteAssessment, setAssessmentId, setHistoryAssessmentId, setShowDeleteConfirmation)
  }

  // Default set to lock/unlock status
  useEffect(()=>{
  let getlockassessment = [];   
  assessmnetHistoryData?.followuphistory?.map(data=>{
    data?.assessments?.map(item=>{
      if(item?.isLocked === 1){
        setLockUnlockToggleLockedOne(true)
        return(
          getlockassessment.push(data?.id)          
        )
      }
      else{
        setLockUnlockToggleLockedZero(false)
        setLockUnlockToggleLockedOne(false)
      }
    })
  })
  },[assessmnetHistoryData])  

  // Lock/unlock functionality
  const changeLockUnlockLockedOnePopup = (assessmentid, lockValue, signValue) => {
    const payloadObj = {
      'assessmentid' : assessmentid,
      'lockValue': lockValue,
      'signValue': signValue,
      'LUONE': true
    }
    setGetObject(payloadObj)
    setLockUnlockToggleLockedOnePopup(true)
    setLockUnlockToggleLockedOne(prev => !prev)
    setLockUnlockToggleLockedZeroPopup(false)
  }
  const changeLockUnlockLockedZeroPopup = (assessmentid, lockValue, signValue) => {
    const payloadObj = {
      'assessmentid' : assessmentid,
      'lockValue': lockValue,
      'signValue': signValue,
      'LUONE': false
    }
    setGetObject(payloadObj)
    setLockUnlockToggleLockedZeroPopup(true)
    setLockUnlockToggleLockedZero(prev => !prev)
    setLockUnlockToggleLockedOnePopup(false)
  }

  const onClickToggleLockUnlock = () => {
    setToggleClicked(true)
  }  

  const lockUnlockConfirmation = () => {
    let assessmentid = getObject.assessmentid
    let lockValue = getObject.lockValue
    let signValue = getObject.signValue
    let latestReEvalId = parseInt(assessmnetHistoryData?.followuphistory?.map(data=>data?.assessments?.map(item=>item))?.map(ele=>ele[0]?.id));
    if(getObject.LUONE === true){
      changeLockUnlockLockedOne(assessmentid, lockValue, signValue)
      setToggleClicked(false)
      if(latestReEvalId===assessmentid){
        setLatestReEval(true)
      } 
      if(latestReEvalId!==assessmentid){
        setLatestReEval(false)
      }
    }
    if(getObject.LUONE === false){
      changeLockUnlockLockedZero(assessmentid, lockValue, signValue)
      setToggleClicked(false)
      if(latestReEvalId===assessmentid){
        setLatestReEval(true)
      } 
      if(latestReEvalId!==assessmentid){
        setLatestReEval(false)
      }
    }
  }

  const changeLockUnlockLockedOne = (assessmentid, lockValue, signValue) => {
    let getLockValue = lockValue === 1 ? 0 : 1; 
    dispatch(setAssessmentHistory({}));
    const assessment = {'signed':signValue, 'locked': getLockValue}
    const assessmentId = assessmentid
    let payload = {
      patientId,
      assessmentId,
      assessment
    }
    dispatch(ne1updateassessmentsignlockAsync(payload)).then(() => {
      setLockUnlockDone(true);
    })        
    // isLockedOneAssessment(assessmentid, getLockValue, signValue)
  }

  const changeLockUnlockLockedZero = (assessmentid, lockValue, signValue) => {
    let getLockValue = lockValue === 1 ? 0 : 1;
    dispatch(setAssessmentHistory({}));
    const assessment = {'signed':signValue, 'locked': getLockValue}
    const assessmentId = assessmentid
    let payload = {
      patientId,
      assessmentId,
      assessment
    }
    dispatch(ne1updateassessmentsignlockAsync(payload)).then(() => {
      setLockUnlockDone(true);
    })
    // isLockedZeroAssessment(assessmentid, getLockValue, signValue)
  } 
  
  // const isLockedOneAssessment = (assessmentid, lockValue, signValue) => {
  //   const assessment = {'signed':signValue, 'locked': lockValue}
  //   const assessmentId = assessmentid
  //   let payload = {
  //     patientId,
  //     assessmentId,
  //     assessment
  //   }
  //   dispatch(ne1updateassessmentsignlockAsync(payload))
  //   setLockUnlockDone(true)
  // }
  // const isLockedZeroAssessment = (assessmentid, lockValue, signValue) => {   
  //   const assessment = {'signed':signValue, 'locked': lockValue}
  //   const assessmentId = assessmentid
  //   let payload = {
  //     patientId,
  //     assessmentId,
  //     assessment
  //   }
  //   dispatch(ne1updateassessmentsignlockAsync(payload))
  //   setLockUnlockDone(true)    
  // }

  useEffect(()=>{
    if(lockUnlockDone){   
      setLockUnlockToastMsg(false)   
      setTimeout(()=>{
        setTinyDelay(false)
        dispatch(patientAssessmentHistoryAsync(patientId, assessmentId));
        loadOffAssessment()
        setLockUnlockToastMsg(true)
      },500)      
    }
  },[lockUnlockDone])
  
  const loadOffAssessment = () => {
    if(latestReEval){
      dispatch(patientAssessmentAsync(patientId, DEFAULT_ASSESSMENT_LIMIT_OFFSET))
    }
    setTimeout(()=>{
      setTinyDelay(true)
      setLockUnlockToastMsg(false)
      setOpenTooltip(false)
      setClickThreeDots('')
      setHoverUnlockIcon(false)
      setHoverMergeIcon(false)
      setHoverDeleteIcon(false)
      setLockUnlockToggle(false)
      setLockUnlockDone(false) 
      setLockUnlockToggleLockedZero(false)
      setLockUnlockToggleLockedOne(false)
      setLockUnlockToggleLockedZeroPopup(false)
      setLockUnlockToggleLockedOnePopup(false)     
    },3000) 
  }

  // Merge functionality
  const onMergeChange = (valueId) => {
    let adminPage = false;
    navigate('/patients' + `/${patientId}` + '/assessment/' + valueId + '/' + 'mergewoundassessment', {
      state: adminPage
    })
    dispatch(setDetailAssessment({}));
    dispatch(setAssessmentHistory({}));
    dispatch(setWoundAssessment("reset"));
  }

  // New create functionality
  
  const onNewWoundCreatePopup = (assessmentId) => {
    setOnNewWoundCreateConfirm(true)
    setOnNewWoundCreateId(assessmentId)
  }

  const onNewWoundCreate = () => {  
    let payload = {
        "patientId": patientId,
        "assessmentId": `${onNewWoundCreateId}`,
    }
    setOnNewWoundCreateConfirm(false)
    dispatch(createNewParentFromChild(payload, modalType, navigate))
  }

  useEffect(()=>{
    if(childAsItsOwnParentAssessment){
      const finalArrValue = parseInt(assessmnetHistoryData?.followuphistory?.map(data=>data?.assessments?.filter(item=>item.id!==assessmentId))?.map(item=>item[0]?.id))
      setTimeout(()=>{
        setTinyDelay(false)
        dispatch(patientAssessmentHistoryAsync(patientId, finalArrValue));
        loadOffAssessmentNewWound()
      },300) 
    }
  },[childAsItsOwnParentAssessment])

  const loadOffAssessmentNewWound = () => {
    setTimeout(()=>{
      setTinyDelay(true)
      if(assessmnetHistoryData?.followuphistory.length > 0){
        setmodalShow(false)
        setNewWoundOptionChildLevel(true)
      }
    },1000) 
  }

  // useEffect(()=>{
  //   if(Array.isArray(assessmnetHistoryData?.followuphistory) && assessmnetHistoryData?.followuphistory.length === 0) {
  //     dispatch(patientAssessmentAsync(patientId, DEFAULT_ASSESSMENT_LIMIT_OFFSET))
  //     // modalRefresh()
  //   }
  // },[assessmnetHistoryData])

  const onTransferChange = (valueId, reEvalCount) => {
    let adminPage = false; 
    navigate('/patients' + `/${patientId}` + '/assessment/' + valueId + '/' + 'transferwoundassessment', {
      state: adminPage
    });
    dispatch(setDetailAssessment({}));
    dispatch(setAssessmentHistory({}));
    dispatch(setWoundAssessment("reset")); 
  }

  const getAllMatchingChildIds = (parentItem) =>
    parentItem?.assessments
      ?.filter((a) => ["signedlocked"].includes(a.assessmentStage))
      ?.map((a) => a.id)
      ?.slice(0, CONSOLIDATE_PDF_MAX_COUNT) || [];

  const handleSelectOne = (parentIndex, childId) => {
    setSelectedIdsByWound((prev) => {
      const prevIds = prev[parentIndex] || [];
      return {
        ...prev,
        [parentIndex]: prevIds.includes(childId) ? prevIds.filter((i) => i !== childId) : [...prevIds, childId],
      };
    });
  };


  const handleSelectAll = (parentIndex, parentItem) => {
    const allIds = getAllMatchingChildIds(parentItem);
  
    setSelectedIdsByWound((prev) => {
      const alreadySelected = prev[parentIndex]?.length === allIds.length;
      return {
        ...prev,
        [parentIndex]: alreadySelected ? [] : allIds,
      };
    });
  };

  const handleDownloadConsolidatePDF = (woundTitle, selectedIds) => {
    const match = woundTitle?.match(/#(\d+):/);
    const woundNumber = match ? parseInt(match[1], 10) : null;
    const payload = {
      Ne1Id: patientData?.ne1Id,
      WoundNumber: woundNumber,
      Assessmentid: selectedIds,
      facilityNumber: patientData?.facilityNumber,
    };

    dispatch(getConsolidatePdfAsync(payload));
  };

  return (
    <>
      <Modal
        modalOpen={modalOpen}
        modalClose={modalRefresh}
        modalSize={style.custom_modal_size}
        pdfModal={pdfModal}
      >
        {
          <div className={style.parent}>
            <div>
              <div className={`${style.modal_heading} pl-4 pt-3 mt-3`}>Assessment History</div>
              {deleteAdminChildStatus && <div className={`alert alert-success ${style.form_alert} ${style.deleteToastMsg}`}>{'Wound deleted successfully'}</div>}
              {lockUnlockToastMsg && detailAssessment?.locked===1  && <div className={lockUnlockToastMsg && detailAssessment?.locked===1 ? `alert alert-success ${style.form_alert} ${style.deleteToastMsg}`: 'd-none'}>{'Wound has been locked'}</div>}
              {lockUnlockToastMsg && detailAssessment?.locked===0  && <div className={lockUnlockToastMsg && detailAssessment?.locked===0 ? `alert alert-success ${style.form_alert} ${style.deleteToastMsg}`: 'd-none'}>{'Wound has been unlocked'}</div>}
            </div>
            <button type="button" className={!pdfModal && `close ${style.close_icon}`} onClick={() => modalRefresh()}>&times;</button>
            <br />
            {!tinyDelay ? <div className={style.loader_fix}><img src={Loader} alt="loading" /></div>

              :
              <>
              {lockUnlockToggleLockedOnePopup && toggleClicked && 
                <Confirmation  onClose={() => setLockUnlockToggleLockedOnePopup(false)} title={" "}>
                  <div className="text-center pr-5 pl-5">
                    <p>
                      <img src={warning} alt="warnning-icon" />
                    </p>
                    <p className="pb-3">
                    {!lockUnlockToggleLockedOne ? 'Do you want to unlock the assessment for this wound?' : 'Do you want to lock the assessment for this wound?'}
                    </p>
                    <div className="mb-2">                      
                      <Button
                        id="closeId"
                        value="No"
                        classes={{ className: `btn mr-4 pb-2 pt-2 ${style.no_btn}` }}
                        onClick={() => setLockUnlockToggleLockedOnePopup(false)}
                      />
                      <Button
                        value="Yes"
                        classes={{
                          className: `btn mr-2 pb-2 pt-2 ml-2 ${style.yes_btn}`,
                        }}
                        onClick={() => lockUnlockConfirmation()}
                      />
                    </div>
                  </div>
              </Confirmation>     
              } 

              {lockUnlockToggleLockedZeroPopup && toggleClicked && 
                <Confirmation  onClose={() => setLockUnlockToggleLockedZeroPopup(false)} title={" "}>
                  <div className="text-center pr-5 pl-5">
                    <p>
                      <img src={warning} alt="warnning-icon" />
                    </p>
                    <p className="pb-3">
                    {!lockUnlockToggleLockedZero ? 'Do you want to unlock the assessment for this wound?' : 'Do you want to lock the assessment for this wound?'}
                    </p>
                    <div className="mb-2">                      
                      <Button
                        id="closeId"
                        value="No"
                        classes={{ className: `btn mr-4 pb-2 pt-2 ${style.no_btn}` }}
                        onClick={() => setLockUnlockToggleLockedZeroPopup(false)}
                      />
                      <Button
                        value="Yes"
                        classes={{
                          className: `btn mr-2 pb-2 pt-2 ml-2 ${style.yes_btn}`,
                        }}
                        onClick={() => lockUnlockConfirmation()}
                      />
                    </div>
                  </div>
              </Confirmation>     
              } 

              {onNewWoundCreateConfirm && 
                <Confirmation  onClose={() => setOnNewWoundCreateConfirm(false)} title={" "}>
                  <div className="text-center pr-5 pl-5">
                    <p>
                      <img src={warning} alt="warnning-icon" />
                    </p>
                    <p className="pb-3">
                    {'Do you want to change this assessment to a new wound?'}
                    </p>
                    <div className="mb-2">                      
                      <Button
                        id="closeId"
                        value="No"
                        classes={{ className: `btn mr-4 pb-2 pt-2 ${style.no_btn}` }}
                        onClick={() => setOnNewWoundCreateConfirm(false)}
                      />
                      <Button
                        value="Yes"
                        classes={{
                          className: `btn mr-2 pb-2 pt-2 ml-2 ${style.yes_btn}`,
                        }}
                        onClick={onNewWoundCreate}
                      />
                    </div>
                  </div>
                </Confirmation>
              }
                {assessmnetHistoryData?.followuphistory?.length !== 0 ? <>                  
                  {
                    assessmnetHistoryData && assessmnetHistoryData?.followuphistory?.map((item, parentIndex) => {
                      return (
                        <div className={style.admission_status_space} key={item?.woundTitle}>
                          <div className={`pl-4 ${style.sub_heading}`}>{`${item.woundTitle}`}</div>
                          <div className={`pl-4 pr-4 mb-2 mt-1 pt-1 ${style.admission_status}`}>
                            History/Cause: <span>{getHistoryCauseText(item, historyCause)}</span>
                          </div>
                          <div className={`pl-4 pr-4 mb-2 pb-1 mt-1 ${style.admission_status}`}>
                            {`Admission Date: ${fullMonthFormatDate(item.admissionDate)} ${item?.dischargeDate ? `| Discharged Date: ${fullMonthFormatDate(item.dischargeDate)}` : ""}`}
                          </div>
                          <div className={`pl-4 pr-4 mb-2 pb-1 mt-1 ${style.admission_status}`}>
                            {patientData?.isConsolidatedPdfEnable === 1 && selectedIdsByWound[parentIndex]?.length > 0 && (
                              <Button
                                type="button"
                                classes={{ className: `btn pr-3 pl-3 ${style.btn_custom_download}` }}
                                onClick={() => handleDownloadConsolidatePDF(item.woundTitle, selectedIdsByWound[parentIndex])}
                              >
                                Download Consolidated PDF
                              </Button>
                            )}
                            {/* {patientData?.isConsolidatedPdfEnable === 1 && selectedIdsByWound[item.woundTitle]?.length > 0 && (
                              <Button
                                type="button"
                                classes={{ className: `btn pr-3 pl-3 ${style.btn_custom_download}` }}
                                onClick={() => handleDownloadConsolidatePDF(item.woundTitle, selectedIdsByWound[item.woundTitle])}
                              >
                                Download Consolidated PDF
                              </Button>
                            )} */}
                            {consolidatePdfLoading && (
                              <div className={style.info_message}>
                                {
                                  <p>
                                    Creating your PDF report... <span>This won't take long</span>{" "}
                                    <span className={style.loader_fix}>
                                      <img src={Loader} alt="loading" />
                                    </span>
                                  </p>
                                }
                              </div>
                            )}
                          </div>
                          <table className="w-100" cellPadding="0" cellSpacing="0">
                            <thead>
                              <tr className={style.complete_th}>
                                {patientData?.isConsolidatedPdfEnable === 1 && (
                                  <th>
                                    <input
                                      type="checkbox"
                                      className={`mt-2 ${style.consolidate_checkbox}`}
                                      checked={
                                        selectedIdsByWound[parentIndex]?.length === getAllMatchingChildIds(item).length &&
                                        getAllMatchingChildIds(item).length > 0
                                      }
                                      onChange={() => handleSelectAll(parentIndex, item)}
                                    />
                                  </th>
                                )}
                                <th>Wound</th>
                                <th>Record Type</th>
                                <th>Photo Taken On</th>
                                <th>Wound Progress</th>
                                <th>Trend</th>
                                <th>Workflow Status</th>
                                <th>Refusal Status</th>
                                <th>View/Download PDF</th>
                                {(isAdminView || adminAccess) && <th></th>}
                              </tr>
                            </thead>
                            <tbody>
                              {item &&
                                item?.assessments?.map((history, index) => {
                                  const {
                                    color: trendColor,
                                    icon: trendIcon,
                                    name: trendName,
                                  } = trendConfig[history?.trendChangeMetricDetail?.status] || trendConfig.default;
                                  return (
                                    <tr className={`${style.complete_td} mb-2`} key={history?.id}>
                                      {patientData?.isConsolidatedPdfEnable === 1 && (
                                        <td className={style.tr_space}>
                                          <input
                                            type="checkbox"
                                            className={style.consolidate_checkbox}
                                            checked={selectedIdsByWound[parentIndex]?.includes(history.id) || false}
                                            onChange={() => handleSelectOne(parentIndex, history.id)}
                                            disabled={history.assessmentStage !== "signedlocked"}
                                          />
                                        </td>
                                      )}
                                      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
                                        {history.picture ? (
                                          <img src={history.picture} alt="wound" className={style.modal_image} />
                                        ) : (
                                          <img src={LogoImage} alt="wound" className={style.modal_image} />
                                        )}
                                      </td>
                                      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
                                        {history.recordType ? <span className={`${style.recordTypeBatch}`}>{history.recordType}</span> : "-"}
                                      </td>
                                      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
                                        {format(new Date(history.identifiedDate), "LLLL d, yyyy hh:mmaa")}
                                      </td>
                                      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
                                        {history?.woundStage
                                          ? woundProgress?.find((data) => data.key === history.woundStage.toLowerCase())?.value || ""
                                          : ""}
                                      </td>
                                      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
                                        <span style={{ color: trendColor}}>
                                          <i className={`${trendIcon} mr-2`} />
                                          {trendName}
                                        </span>
                                      </td>

                                      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
                                        {assessmentStageGetter(history.assessmentStage)}
                                      </td>
                                      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
                                      {history.refusalReason ? <span className={`${style.recordTypeBadge} ${style.typeReval}`}>{history.refusalReason}</span> : "-"}
                                      </td>
                                      <td className={style.tr_space} key={index}>
                                        {history.assessmentStage === "pendingreview" || history.assessmentStage === "signedlocked" ? (
                                          <span
                                            className={`${style.pdf_link} pl-5`}
                                            onClick={() => {
                                              pdfmodalopen();
                                              setHistoryId(history.id);
                                            }}
                                          >
                                            <img
                                              src={PDFIcon}
                                              alt="pdfIcon"
                                              onClick={() => {
                                                pdfmodalopen();
                                                setHistoryId(history.id);
                                              }}
                                            />
                                          </span>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      {(isAdminView || adminAccess) && (
                                        <td className={style.tr_space}>
                                          <div className={`${style.Three_Dots_Panel_History}`} onClick={() => threeDotPanelClick(history.id)}>
                                            <i
                                              className="fa fa-ellipsis-v"
                                              style={history.id !== clickThreeDots ? { color: "#464646" } : { color: "#919191" }}
                                              aria-hidden="true"
                                            ></i>

                                            {openTooltip && history.id === clickThreeDots && (
                                              <div className={`${style.threeDotsTooltipHistory}`} ref={wrapperRef}>
                                                <div
                                                  className={`${style.lockSection} ${history?.isSigned === 0 && style.toggle_shells_disabled}`}
                                                  onMouseOver={() => {
                                                    setHoverUnlockIcon(true);
                                                  }}
                                                  onMouseLeave={() => {
                                                    setHoverUnlockIcon(false);
                                                  }}
                                                >
                                                  {history?.isLocked === 1 ? (
                                                    <>
                                                      <i
                                                        className={lockUnlockToggleLockedOne ? "fa fa-lock" : "fa fa-unlock-alt"}
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "19px",
                                                          color: !hoverUnlockIcon ? "#505f79" : "#ffffff",
                                                          padding: "0 6px",
                                                        }}
                                                      ></i>
                                                      <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "5px" }}>
                                                        {lockUnlockToggleLockedOne ? "Locked" : "Unlocked"}{" "}
                                                      </p>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <i
                                                        className={lockUnlockToggleLockedZero ? "fa fa-lock" : "fa fa-unlock-alt"}
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "19px",
                                                          color: !hoverUnlockIcon ? "#505f79" : "#ffffff",
                                                          padding: "0 6px",
                                                        }}
                                                      ></i>
                                                      <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "5px" }}>
                                                        {lockUnlockToggleLockedZero ? "Locked" : "Unlocked"}{" "}
                                                      </p>
                                                    </>
                                                  )}
                                                  {history?.isLocked === 1 ? (
                                                    <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}>
                                                      <input
                                                        type="checkbox"
                                                        name={history?.id}
                                                        className="custom-control-input"
                                                        id={history?.id}
                                                        data-testid={"toggleSwitch"}
                                                        // defaultValue = {}
                                                        // checked = {traveNurse === 1}
                                                        // onChange={checkHandleClick}
                                                        defaultChecked={!lockUnlockToggle && history?.isLocked === 1}
                                                        onChange={() =>
                                                          changeLockUnlockLockedOnePopup(history?.id, history?.isLocked, history?.isSigned)
                                                        }
                                                        onClick={() => onClickToggleLockUnlock()}
                                                      />
                                                      <label className={`custom-control-label ${style.toggle_switch}`} htmlFor={history?.id}></label>
                                                    </div>
                                                  ) : (
                                                    <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}>
                                                      <input
                                                        type="checkbox"
                                                        name={history?.id}
                                                        className="custom-control-input"
                                                        id={history?.id}
                                                        data-testid={"toggleSwitch"}
                                                        // defaultValue = {}
                                                        // checked = {traveNurse === 1}
                                                        // onChange={checkHandleClick}
                                                        disabled={history?.isSigned === 0}
                                                        onChange={() =>
                                                          changeLockUnlockLockedZeroPopup(history?.id, history?.isLocked, history?.isSigned)
                                                        }
                                                        onClick={() => onClickToggleLockUnlock()}
                                                      />
                                                      <label className={`custom-control-label ${style.toggle_switch}`} htmlFor={history?.id}></label>
                                                    </div>
                                                  )}
                                                </div>
                                                <div
                                                  className={`${style.mergeSection}`}
                                                  onMouseOver={() => {
                                                    setHoverMergeIcon(true);
                                                  }}
                                                  onMouseLeave={() => {
                                                    setHoverMergeIcon(false);
                                                  }}
                                                  onClick={() => onMergeChange(history.id)}
                                                >
                                                  <svg
                                                    data-name="Component 124 – 3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="27"
                                                    height="25"
                                                    viewBox="0 0 32 32"
                                                    style={{ paddingLeft: "3px" }}
                                                  >
                                                    <path data-name="Rectangle 194" style={{ fill: "none" }} d="M0 0h32v32H0z" />
                                                    <path
                                                      d="M22.221 3a1.131 1.131 0 0 1 1.131 1.131v18.09a1.131 1.131 0 0 1-1.131 1.131H4.131A1.131 1.131 0 0 1 3 22.221V4.131A1.131 1.131 0 0 1 4.131 3zM12.045 5.261H5.261v6.783h2.262v-2.26l3.392 3.392-3.392 3.392v-2.261H5.261v6.783h6.784v-2.261h2.261v2.261h6.784v-6.783h-2.261v2.261l-3.392-3.392 3.392-3.392v2.26h2.261V5.261h-6.783v2.262h-2.262zm2.261 9.045v2.261h-2.261v-2.26zm0-4.523v2.261h-2.261v-2.26z"
                                                      transform="translate(2 3)"
                                                      style={{ fill: !hoverMergeIcon ? "#505f79" : "#ffffff" }}
                                                    />
                                                  </svg>
                                                  <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "5px" }}>Merge </p>
                                                  <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}></div>
                                                </div>
                                                <div
                                                  className={`${style.transferSection} ${
                                                    history.recordType === "Initial Assessment" && style.toggle_shells_disabled
                                                  }`}
                                                  onMouseOver={() => {
                                                    setHoverTransferIcon(true);
                                                  }}
                                                  onMouseLeave={() => {
                                                    setHoverTransferIcon(false);
                                                  }}
                                                  onClick={() => onTransferChange(history.id)}
                                                >
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    shapeRendering="geometricPrecision"
                                                    textRendering="geometricPrecision"
                                                    imageRendering="optimizeQuality"
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    viewBox="0 0 441 512.399"
                                                    width="25"
                                                    height="21"
                                                    style={{ paddingLeft: "3px" }}
                                                  >
                                                    <path
                                                      fill="#000"
                                                      fillRule="nonzero"
                                                      d="M102.778 354.886c-5.727 0-10.372-4.645-10.372-10.372s4.645-10.372 10.372-10.372h85.568a148.22 148.22 0 00-7.597 20.744h-77.971zm0-145.37c-5.727 0-10.372-4.645-10.372-10.372s4.645-10.372 10.372-10.372h151.288c5.727 0 10.373 4.645 10.373 10.372s-4.646 10.372-10.373 10.372H102.778zm0 72.682c-5.727 0-10.372-4.646-10.372-10.372 0-5.728 4.645-10.373 10.372-10.373h143.273c2.829 0 5.394 1.134 7.264 2.971a149.511 149.511 0 00-25.876 17.774H102.778z"
                                                      style={{ fill: !hoverTransferIcon ? "#505f79" : "#ffffff" }}
                                                    />
                                                    <path
                                                      fill="#000"
                                                      d="M324.263 278.925c32.231 0 61.419 13.067 82.545 34.192C427.933 334.241 441 363.43 441 395.66c0 32.236-13.067 61.419-34.192 82.544-21.126 21.126-50.311 34.195-82.545 34.195-32.232 0-61.418-13.069-82.542-34.195-21.126-21.125-34.195-50.312-34.195-82.544s13.069-61.417 34.195-82.543c21.125-21.125 50.308-34.192 82.542-34.192zM60.863 0h174.81c3.382 0 6.384 1.619 8.278 4.123l110.107 119.12a10.288 10.288 0 012.746 7.011h.052v119.819a149.42 149.42 0 00-20.752-3.112v-92.212h-43.666v-.042h-.161c-22.046-.349-39.33-6.222-51.694-16.784-12.849-10.979-20.063-26.615-21.503-46.039a10.16 10.16 0 01-.096-1.405V20.752H60.863c-11.02 0-21.049 4.518-28.321 11.79-7.272 7.272-11.79 17.301-11.79 28.321v338.276c0 11.015 4.521 21.038 11.796 28.312 7.278 7.28 17.31 11.801 28.315 11.801h120.749a148.33 148.33 0 008.116 20.752H60.863c-16.73 0-31.958-6.849-42.987-17.881C6.852 431.099 0 415.882 0 399.139V60.863C0 44.114 6.846 28.894 17.87 17.87 28.894 6.846 44.114 0 60.863 0zm178.873 29.983v60.432c1.021 13.738 5.819 24.536 14.302 31.784 8.668 7.404 21.488 11.544 38.4 11.835v-.038h43.443L239.736 29.983zm24.119 381.587v-31.799c0-6.683 5.451-12.132 12.12-12.132h34.763v-22.387c.166-4.041 1.51-6.904 4.028-8.557 6.739-4.495 13.386 1.643 18.071 5.895l46.127 45.371c4.818 4.896 4.884 10.557 0 15.45l-47.393 46.461c-4.484 3.985-10.599 8.914-16.805 4.762-2.518-1.686-3.862-4.529-4.028-8.568V423.69h-34.763c-6.615 0-12.12-5.449-12.12-12.12z"
                                                      style={{ fill: !hoverTransferIcon ? "#505f79" : "#ffffff" }}
                                                    />
                                                  </svg>
                                                  <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "5px" }}>Transfer</p>
                                                  <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}></div>
                                                </div>
                                                <div
                                                  className={`${style.newWoundSection}`}
                                                  onMouseOver={() => {
                                                    setHoverNewWound(true);
                                                  }}
                                                  onMouseLeave={() => {
                                                    setHoverNewWound(false);
                                                  }}
                                                  onClick={() => onNewWoundCreatePopup(history.id)}
                                                >
                                                  <svg
                                                    data-name="Component 124 – 3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="27"
                                                    height="27"
                                                    viewBox="0 0 32 32"
                                                  >
                                                    <path data-name="Rectangle 194" style={{ fill: "none" }} d="M0 0h32v32H0z" />
                                                    <path
                                                      data-name="New Wound Dark"
                                                      d="M6 19.771A6 6 0 0 1 1.755 9.532l7.778-7.778a6 6 0 1 1 8.485 8.485l-7.779 7.778a5.984 5.984 0 0 1-4.232 1.754zm2.89-6.885a.995.995 0 1 0 .291-.708 1 1 0 0 0-.291.708zm3-3a.993.993 0 1 0 .29-.709 1 1 0 0 0-.29.709zm-6 0a.995.995 0 1 0 .291-.708 1 1 0 0 0-.291.708zm3-3a.995.995 0 1 0 .291-.708 1 1 0 0 0-.291.708zm8.3 12.157v-1.455h-1.463a.728.728 0 0 1 0-1.455h1.455v-1.456a.728.728 0 1 1 1.455 0v1.455h1.455a.728.728 0 1 1 0 1.455h-1.454v1.455a.728.728 0 0 1-1.455 0z"
                                                      transform="translate(4.999 6.004)"
                                                      style={{ fill: !hoverNewWound ? "#505f79" : "#ffffff" }}
                                                    />
                                                  </svg>
                                                  <p style={{ alignItems: "baseline", paddingTop: "3px", paddingLeft: "4px" }}>New wound </p>
                                                  <div className={`${style.toggle_shells} custom-control custom-switch ml-auto`}></div>
                                                </div>
                                                <div
                                                  className={`${style.deleteSection} ${
                                                    history.recordType === "Initial Assessment" && style.toggle_shells_disabled
                                                  }`}
                                                  onClick={() => openDeleteConfirmation(history.id, "", item?.woundTitle)}
                                                  onMouseOver={() => {
                                                    setHoverDeleteIcon(true);
                                                  }}
                                                  onMouseLeave={() => {
                                                    setHoverDeleteIcon(false);
                                                  }}
                                                >
                                                  <svg
                                                    data-name="Component 124 – 3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="25"
                                                    height="25"
                                                    viewBox="0 0 32 32"
                                                    style={{ paddingLeft: "3px" }}
                                                  >
                                                    <path data-name="Rectangle 194" style={{ fill: "none" }} d="M0 0h32v32H0z" />
                                                    <path
                                                      data-name="Delete Dark"
                                                      d="M71.714 67.366v-2.573a.857.857 0 0 1 .857-.857h6.857a.857.857 0 0 1 .857.857v2.573h6.857a.857.857 0 1 1 0 1.714H64.857a.857.857 0 0 1 0-1.714zm1.714 0h5.143v-1.714h-5.142zm-6 20.571a.857.857 0 0 1-.857-.857v-18h18.858v18a.857.857 0 0 1-.857.857zm6-5.143a.857.857 0 0 0 .857-.857v-8.571a.857.857 0 1 0-1.714 0v8.571a.857.857 0 0 0 .858.858zm5.143 0a.857.857 0 0 0 .857-.857v-8.571a.857.857 0 0 0-1.714 0v8.571a.857.857 0 0 0 .857.858z"
                                                      transform="translate(-60 -59.936)"
                                                      style={{ fill: !hoverDeleteIcon ? "#505f79" : "#ffffff" }}
                                                    />
                                                  </svg>
                                                  <p
                                                    style={{ alignItems: "baseline", paddingTop: "2px", paddingLeft: "5px" }}
                                                    onClick={() => openDeleteConfirmation(history.id)}
                                                  >
                                                    Delete{" "}
                                                  </p>
                                                  <div
                                                    className={`${style.toggle_shells} custom-control custom-switch ml-auto`}
                                                    onClick={() => openDeleteConfirmation(history.id)}
                                                  ></div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </td>
                                      )}
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      );
                    })
                  }
                </>
                  :

                  <h4 className="text-center p-4">No data available.</h4>

                }
              </>
            }

          </div>
        }
      </Modal>

      {/* confirmation */}
      {
        showDeleteConfirmation && <Confirmation
          onClose={() => setShowDeleteConfirmation(false)}
          title={" "}
        >
          <div className="text-center pr-5 pl-5">
            <p>
              <img src={warning} alt="warnning-icon" />
            </p>
            <p className="pb-3">Do you wish to delete<br/><b>{assessTitleContent}?</b></p>
            <div className="mb-2">
              <Button
                value="No"
                classes={{ className: `btn mr-3 ml-2 pb-2 pt-2 ${style.no_btn}` }}
                onClick={() => setShowDeleteConfirmation(false)}
              />
              <Button
                value="Yes"
                classes={{ className: `btn mr-2 pb-2 pt-2 ${style.yes_btn}` }}
                onClick={handleDelete}
              />
            </div>
          </div>
        </Confirmation>
      }

      {/* added for Pdf with/without Image */}
        {pdfModal && <Modal
          modalOpen={pdfmodalopen}
          modalClose={pdfmodalclose}
          modalSize={style.custom_modal_size_pdf}
        >
          {
            <div className={style.modalparent}>
              <div className={`${style.modal_heading_pdf} pb-2`}>
                <div className={`${style.modal_header_pdf} pl-3 pt-3`}>
                  <h3>PDF Download</h3>
                </div>
                <button type="button" className={`close ${style.close_icon_pdf} pr-3`} onClick={() => pdfmodalclose()}>&times;</button>
              </div>
            
              <div className={`${style.modal_footer}`}>
                <div className={'px-4 mt-5'}>
                  <h2> Do you want to include <br /> wound images? </h2>
                </div>
                <div className={'d-flex justify-content-center px-3 pt-5 pb-2'}>
                <Button
                      type="submit"
                      value="Yes"
                      classes={{ className: `btn btn-small ml-0 mr-5 ${style.btn_small} ${style.btn_custom}` }}
                      id="save"
                      onClick={()=>pdfPageTrue(historyId)}
                  />
                  
                  <Button
                      type="button"
                      value="No"
                      classes={{ className: `btn btn-small ${style.btn_small_cancel} ${style.btn_custom} ml-4` }}
                      id="cancel"
                      onClick={()=>pdfPageFalse(historyId)}                                                                          
                  />
                </div>
              </div>
            
            <br />
            

          </div>
          }        
        </Modal>
      }
      {/* added for Pdf with/without Image */}
      
    </>
  )
}
